const Locations = {
  locationsPath: () => '/Agency/Rails/Locations',
  getAllLocations: () => '/ExternalSale/GetLocations',
  getNewLocations: () => '/Locations',
};

export default Locations;
